import TerraKit from '@terra-js/terra-kit';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const cartTokenLSKey = "cart_token";
const BUY_NOW_ISOLATED_CART_TYPE = "buy_now";
var IsolatedCartType = /* @__PURE__ */ ((IsolatedCartType2) => {
  IsolatedCartType2["BUY_NOW"] = "buy_now";
  IsolatedCartType2["INSTALLMENT"] = "installment_vnpay";
  return IsolatedCartType2;
})(IsolatedCartType || {});
const BUY_NOW_CARTS_KEY = "buy-now-carts";
const BUY_NOW_CART_KEY_LENGTH = 6;
const BUY_NOW_CART_EXPIRED_ERROR_CODE = 404101;
const getCartToken = () => {
  return localStorage.getItem(cartTokenLSKey);
};
const setCartToken = (value) => {
  localStorage.setItem(cartTokenLSKey, value);
};
const removeCartToken = () => localStorage.removeItem(cartTokenLSKey);
const defaultCart = {
  id: "",
  items: [],
  priceSummary: [
    {
      name: "T\u1ED5ng ti\u1EC1n",
      value: "0\u0111"
    },
    {
      name: "Th\xE0nh ti\u1EC1n",
      value: "0\u0111"
    }
  ],
  grandTotalAmount: 0,
  paidAmount: 0,
  remainingAmount: 0,
  onDemandDiscount: 0,
  allowedUserActions: [],
  promotions: [],
  paymentMethods: [],
  orderTerminalCode: ""
};
const generateRandomString = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
let lastBuyNowKey = "";
const getBuyNowKey = (isReuse) => {
  if (isReuse) {
    return lastBuyNowKey;
  }
  const newBuyNowKey = generateRandomString(BUY_NOW_CART_KEY_LENGTH);
  lastBuyNowKey = newBuyNowKey;
  return newBuyNowKey;
};
const storeBuyNowCartKey = (newBuyNowCart) => {
  if (TerraKit.isAvailable())
    return;
  const buyNowCarts = JSON.parse(localStorage.getItem(BUY_NOW_CARTS_KEY) || "[]");
  buyNowCarts.push(newBuyNowCart);
  localStorage.setItem(BUY_NOW_CARTS_KEY, JSON.stringify(buyNowCarts));
};
const removeOldBuyNowCart = () => {
  if (TerraKit.isAvailable())
    return;
  const hamperData = JSON.parse(localStorage.getItem("buildHamper") || "{}");
  const oldCartToken = hamperData.cartToken;
  if (!oldCartToken)
    return;
  let buyNowCarts = JSON.parse(localStorage.getItem(BUY_NOW_CARTS_KEY) || "[]");
  buyNowCarts = buyNowCarts.filter((item) => item.cartToken !== oldCartToken);
  localStorage.setItem(BUY_NOW_CARTS_KEY, JSON.stringify(buyNowCarts));
};
const storeCartTokenHamper = (cartToken) => {
  const hamperLocalStorageKey = TerraKit.isAvailable() ? "buildHamperApp" : "buildHamper";
  let hamperData = JSON.parse(localStorage.getItem(hamperLocalStorageKey) || "{}");
  hamperData = __spreadProps(__spreadValues({}, hamperData), { cartToken });
  localStorage.setItem(hamperLocalStorageKey, JSON.stringify(hamperData));
};
const setCartInfoToLocalStorage = (cartId, data) => {
  const { newCartToken, oldCartToken, terminalId, cartDiffDetails } = data;
  localStorage.setItem(`cart.${cartId}`, JSON.stringify(__spreadValues(__spreadValues({
    token: newCartToken,
    referencedToken: oldCartToken
  }, terminalId && { terminalId }), cartDiffDetails && { cartDiffDetails })));
};

export { BUY_NOW_CARTS_KEY, BUY_NOW_CART_EXPIRED_ERROR_CODE, BUY_NOW_CART_KEY_LENGTH, BUY_NOW_ISOLATED_CART_TYPE, IsolatedCartType, defaultCart, getBuyNowKey, getCartToken, removeCartToken, removeOldBuyNowCart, setCartInfoToLocalStorage, setCartToken, storeBuyNowCartKey, storeCartTokenHamper };
